module.exports = __webpack_public_path__ + "resources/com-status-loading.5d4195a63f031b63.png";